import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const PdfViewerModal = ({ 
  show, 
  onHide, 
  title = 'Vista Previa del Documento', 
  url, 
  size = 'xl'
}) => {
  const [pdfLoading, setPdfLoading] = useState(false);

  const handleCloseModal = () => {
    setPdfLoading(false);
    onHide();
  };

  const handleOpenInNewTab = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Reset loading state when URL changes
  useEffect(() => {
    if (show && url) {
      setPdfLoading(true);
      // Simular un pequeño delay para mostrar el loading
      const timer = setTimeout(() => setPdfLoading(false), 500);
      return () => clearTimeout(timer);
    }
  }, [show, url]);

  return (
    <Modal 
      show={show} 
      onHide={handleCloseModal} 
      size={size}
      className="pdf-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3">Cargando el documento...</p>
          </div>
        ) : (
          <div className="pdf-embed-container">
            <iframe
              src={url}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{ border: 'none' }}
              title={title}
              allow="fullscreen"
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <button className="btn btn-light-secondary" onClick={handleCloseModal}>
          <i className="fas fa-times me-2"></i>
          Cerrar
        </button>
        <button className="btn btn-light-primary" onClick={handleOpenInNewTab}>
          <i className="fas fa-external-link-alt me-2"></i>
          Abrir en Nueva Pestaña
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PdfViewerModal;
